export const POINT_MAX_FILE_SIZE = 104857600; // 100 MB
